import { MenuItem } from './rich-data.model';

/* eslint-disable @typescript-eslint/naming-convention */
export class ProfileFollowModel {
    id: number;
    hotel_id: number;
    profile_id: number;
    followed_type: string;
    followed_id: number;
    followed_name: string;
    followed: boolean;
    followed_date: Date;
    un_followed_date: Date;

    constructor(menuItem: MenuItem, isFollow: boolean, profileId: number) {
        this.id = 0;
        this.hotel_id = menuItem.hotel_id;
        this.profile_id = profileId;
        this.followed_type = 'MenuIten';
        this.followed_id = menuItem.id;
        this.followed_name = menuItem.name;
        this.followed = isFollow;
        this.followed_date = new Date();
        this.un_followed_date = new Date();
    }
}
